<template>
  <simple-activity :closeIsCancel="formField && !formField.readOnly"
                   :show-header="isTextual && formField && !formField.readOnly">

    <!-- HEADER -->
    <!-- Left side button - primary actions -->
    <template v-slot:primaryButton>
      <div class="p-1">
        <b-button
            v-if="isTextual" :disabled="load" data-test-path="translateAll" variant="outline-primary"
            @click="translationList()">
          <div v-if="!load">
            <font-awesome-icon class="mr-2" icon="language"/>
            {{ $tr('TextInputTranslationDialog.translateAll', 'Translate all') }}
          </div>
          <div v-else>
            <font-awesome-icon :icon="['fas', 'spinner-third']" spin/>
          </div>
        </b-button>
        <b-button v-if="isTextual && formField && !formField.readOnly && mayNeedFix" variant="outline-primary"
                  @click="fixTranslations()">
          <div v-if="!load">
            <font-awesome-icon class="mr-2" icon="wrench"/>
            {{ $tr('Correct translations', 'Correct translations') }}
          </div>
          <div v-else>
            <font-awesome-icon :icon="['fas', 'spinner-third']" spin/>
          </div>
        </b-button>
      </div>
    </template>

    <!-- toolbars -->
    <template v-slot:toolButtons>

    </template>

    <!-- danger actions on the right -->
    <template v-slot:dangerButton>

    </template>
    <!-- HEADER END-->
    <b-container fluid>
      <b-row>
        <b-col>
          <b-button
              v-if="calculatePricesButtonEnabled && !formField.readOnly" data-test-path="calculateThePrices"
              variant="outline-primary"
              @click="calculatePrices()">
            <div>
              <font-awesome-icon class="mr-2" icon="language"/>
              {{ $tr('TextInputTranslationDialog.computePrices', 'Calculate the Prices') }}
            </div>
          </b-button>
          <b-container>
            <b-row>
              <b-col>
                <div class="form-group mb-2">
                  <div class="d-flex justify-content-between align-items-center">
                    <label class="currentLanguage my-1" for="input">
              <span v-for="(value, key) in languages" :key="key" v-if="key === typingLanguage">
                {{ $tr('textInputTranslationDialog.CurrentLanguage', 'Current Language') }}: {{ value.name }}
              </span>
                    </label>
                  </div>
                  <!--            -->
                  <!--            <b-form-input-->
                  <!--                id="input-0"-->
                  <!--                v-model="baseName"-->
                  <!--                readonly-->
                  <!--            />-->
                  <automatic-field-renderer
                      v-if="baseSet"
                      v-model="baseName"
                      :fieldConfig="fieldConfig"
                      :formField="formField"
                      :readOnly="!openFromGrid"
                      @val-change="changeVal"
                  ></automatic-field-renderer>

                  <small v-if="(formField && !formField.isValid)" class="form-text text-danger font-weight-bold"
                         style="margin-top: 2px; margin-left: 10px;">{{
                      formField ? formField.errorMessage || '&nbsp;' : ' '
                    }}
                  </small>

                </div>

                <div v-for="(value, key) in languages" v-if="value.hasMoreRegion && key === typingLanguage"
                     :key="'read-only-' + key"
                     class="form-group">
                  <div class="d-flex justify-content-center align-items-center mt-2">
                    <span style="padding: 5px; margin: 5px;">{{
                        $tr('textInputTranslationDialog.regions', 'Regions')
                      }}</span>
                    <b-button size="sm" variant="link" @click="toggleReadOnlyRegions(key)">
                      <font-awesome-icon :icon="expandedReadOnlyRegions[key] ? 'chevron-up' : 'chevron-down'"
                                         class="icon-language"/>
                    </b-button>
                  </div>
                  <b-card v-if="expandedReadOnlyRegions[key]" class="ml-4 mt-2">
                    <div v-for="region in value.regions" :key="region.fixedSymbol" class="form-group">
                      <label :for="'readonly-input-' + region.fixedSymbol">
                        {{ $tr('textInputTranslationDialog.region', 'Region #{1}', region.name) }}
                      </label>
                      <div class="d-flex align-items-center">
                        <!--                  <b-form-input-->
                        <!--                      :id="'readonly-input-' + region.fixedSymbol"-->
                        <!--                      v-model="translatedWords['r_'+region.fixedSymbol]"-->
                        <!--                      class="flex-grow-1"-->
                        <!--                      readonly-->
                        <!--                  />-->
                        <automatic-field-renderer
                            v-model="translatedWords['r_'+region.fixedSymbol]"
                            :fieldConfig="fieldConfig"
                            :formField="formField"
                            :readOnly="true"
                        ></automatic-field-renderer>
                      </div>
                    </div>
                  </b-card>
                </div>
              </b-col>
            </b-row>
            <b-row>
              <b-col>

                <div v-if="languages && languages.length > 1 && formField && !formField.readOnly"
                     class="text-center mb-3 mr-2">

                </div>
                <div v-for="(value, key) in languages" v-if="key !== typingLanguage" :key="key"
                     :data-test-path="'translation-' + value.name" class="form-group">
                  <label :for="'input-' + key">
                    {{ value.name }}
                    <b-button v-if="isTextual && formField && !formField.readOnly && key !== typingLanguage"
                              class="ml-2 translation-button"
                              size="sm" style="width: 40px; height: 26px"
                              variant="outline-primary"
                              @click="translate(typingLanguage, key, baseName)">
                      <div v-if="!load">
                        <font-awesome-icon class="icon-language" icon="language"/>
                      </div>
                      <div v-else>
                        <font-awesome-icon :icon="['fas', 'spinner-third']" spin/>
                      </div>
                    </b-button>
                  </label>
                  <div class="d-flex align-items-center">
                    <!--              <b-form-input-->
                    <!--                  :id="'input-' + key"-->
                    <!--                  v-model="translatedWords[key]"-->
                    <!--                  class="flex-grow-1"-->
                    <!--                  ref="inputs"-->
                    <!--                  :readonly="formField ? formField.readOnly || load : true"-->
                    <!--              />-->
                    <automatic-field-renderer
                        ref="fieldRenderer"
                        v-model="translatedWords[key]"
                        :fieldConfig="fieldConfig"
                        :formField="formField"
                        :readOnly="formField ? formField.readOnly || load : true"
                        :region="key"
                    ></automatic-field-renderer>
                  </div>
                  <div v-if="value.hasMoreRegion" class="d-flex justify-content-center align-items-center mt-2">
                    <span style="padding: 5px; margin: 5px;">{{
                        $tr('textInputTranslationDialog.regions', 'Regions')
                      }}</span>
                    <b-button size="sm" variant="link" @click="toggleRegions(key)">
                      <font-awesome-icon :icon="expandedRegions[key] ? 'chevron-up' : 'chevron-down'"
                                         class="icon-language"/>
                    </b-button>
                  </div>
                  <b-card v-if="value.hasMoreRegion && expandedRegions[key]" class="ml-4 mt-2">
                    <div v-for="region in value.regions" :key="region.fixedSymbol" class="form-group">
                      <label :for="'input-' + region.fixedSymbol">
                        {{ $tr('textInputTranslationDialog.region', 'Region #{1}', region.name) }}
                      </label>
                      <div class="d-flex align-items-center">
                        <!--                  <b-form-input-->
                        <!--                      :id="'input-' + region.fixedSymbol"-->
                        <!--                      v-model="translatedWords['r_'+region.fixedSymbol]"-->
                        <!--                      class="flex-grow-1"-->
                        <!--                      ref="inputs"-->
                        <!--                      :readonly="formField ? formField.readOnly : true"-->
                        <!--                  />-->

                        <automatic-field-renderer
                            v-model="translatedWords['r_'+region.fixedSymbol]"
                            :fieldConfig="fieldConfig"
                            :formField="formField"
                            :readOnly="formField ? formField.readOnly : true"
                        ></automatic-field-renderer>
                      </div>
                    </div>
                  </b-card>
                </div>
              </b-col>
            </b-row>

          </b-container>
        </b-col>
      </b-row>
    </b-container>
    <!-- CONTENT END-->
    <template v-slot:bottomLine>

    </template>

    <template v-slot:footer>
      <save-and-close-button
          v-if="formField && !formField.readOnly"
          :enabled="formField ? (!formField.saveInProgress && formField.isValid) : true"
          @save="onSave"></save-and-close-button>
    </template>
  </simple-activity>
</template>

<script>
import Rpc from "@/Rpc";
import {defaultCurrencyValForRegion, detectDBLanguage, languagesForField} from "@/utils/TranslationDispatcher";
import SimpleActivity from "@/activity/templates/layouts/SimpleActivity.vue";
import FooterButton from "@/components/navbar/FooterButton.vue";
import Activity from "@/activity/Activity";
import DialogManager from "@/utils/DialogManager";
import SaveAndCloseButton from "@/components/navbar/SaveAndCloseButton.vue";
import AutomaticFieldRenderer from "@/components/AutomaticFieldRenderer.vue";
import {TRANSLATABLE_CURRENCY_RENDERERS, TRANSLATABLE_TEXT_RENDERERS} from "@/components/forms/renderers/Renderers";
import {readonly} from "vue";
import FormValidatedField from "@/components/forms/FormValidatedField";
import {cloneClassInstance} from "@/utils/Objects";
import FormsLoader from "@/components/forms/FormsLoader";
import ColorVersion from "@/server/com/silkplm/model/plm/ColorVersion";
import {
  checkIfEnabledByOrganizationFormsSettingsForForm,
  checkIfEnabledByOrganizationFormsSettingsForFormField,
  findFieldValueFromCompanyCompanyConfigurationFormField
} from "@/components/forms/customizations/plm/EntityEditFormService";
import Region from "@/server/com/silkplm/engine/model/Region";
import DecimalFormFieldConfig from "@/server/com/silkplm/engine/forms/schema/definition/DecimalFormFieldConfig";
import DecimalWithCurrency from "@/server/com/silkplm/rpc/dto/DecimalWithCurrency";

export default {
  name: "FieldTranslationActivity",
  components: {AutomaticFieldRenderer, SaveAndCloseButton, FooterButton, SimpleActivity},

  mounted() {
    this.setVisibilityForComputePricesButton();
    this.initTranslationData();
    this.setBaseNameAndLabel();
    this.baseSet = true;
  },

  methods: {
    readonly,
    ...Activity.methods,

    getTitle() {
      return $tr('TextInputTranslationDialog.EditingTranslations', 'Editing Translations for: #{1}', this.baseNameLabel);
    },
    async canClose() {
      return await DialogManager.canClose(this.unsavedChanges);
    },

    setVisibilityForComputePricesButton() {
      if (this.fieldConfig instanceof DecimalFormFieldConfig) {
        if (this.fieldConfig.dataType === "DecimalWithCurrency") {
          let formConfigForRegion = FormsLoader.detectFormConfig(Region.getRemoteClass());
          let activeFieldConfig = formConfigForRegion.fields.filter(item => item.fieldName === 'active');
          let activeFieldForRegionEnabled = checkIfEnabledByOrganizationFormsSettingsForFormField(formConfigForRegion.formId, activeFieldConfig);
          if (activeFieldForRegionEnabled) {
            this.calculatePricesButtonEnabled = activeFieldForRegionEnabled;
          }
        }
      }
    },

    async onSave() {
      let translations = {def: this.objDef.def, ...this.translatedWords};
      this.formField.translations = translations;
      this.setResult({translations, baseVal: this.formField.value});
      this.close();
    },

    setBaseNameAndLabel() {
      if (this.formField && this.formField.label) {
        this.baseNameLabel = this.formField.label;
      }

      if (this.formField && this.formField.translations) {
        if (this.formField.translations[this.typingLanguage]) {
          this.baseName = this.formField.translations[this.typingLanguage];
        }
      }
    },
    changeVal(val) {
      this.formField.value = val;
    },
    async translate(fromLang, toLang, text) {
      this.load = true;
      try {
        const translatedText = await Rpc.Regions.translate(this.typingLanguage, toLang, text);
        this.$set(this.translatedWords, toLang, translatedText);
      } catch (error) {
        console.error('Translation process failed', error);
        alert('An error occurred during the translation process. Please try again later.');
      } finally {
        this.load = false;
      }
    },
    async translationList() {
      this.load = true;
      let langList = [];
      try {

        for (const [key, value] of Object.entries(this.languages)) {
          langList.push(key);
        }

        const newAssignedTranslations = await Rpc.Regions.translateToMultiLang(this.typingLanguage, langList, this.baseName);
        for (const [key, value] of Object.entries(newAssignedTranslations)) {
          if (key !== this.typingLanguage) {
            this.$set(this.translatedWords, key, value);
          }
        }
      } catch (error) {
        console.error('Translation process failed', error);
        alert('An error occurred during the translation process. Please try again later.');
      } finally {
        this.load = false;
      }
    },

    async calculatePrices() {
      if (!this.formField.value?.decimal) {
        for (let ref of this.$refs.fieldRenderer) {
          ref.refresh(null);
        }
        return;
      }
      let results = await Rpc.Regions.computePricesForRegions(this.formField.value);
      for (const [key, value] of Object.entries(results)) {
        if (key !== this.typingLanguage) {
          this.translatedWords[key] = value;
        }
      }
      for (let index in this.$refs.fieldRenderer) {
        const renderer = this.$refs.fieldRenderer[index];
        let value = this.translatedWords[renderer.$props.region];
        renderer.refresh(value);
      }
    },

    async initTextFieldTranslationData() {
      for (let code in this.languages) {
        if (this.languages[code].hasMoreRegion) {
          this.translatedWords["r_" + code] = this.translation["r_" + code] ?? "";
          this.translatedWords[code] = this.translation[code] ?? "";
          for (let region of this.languages[code].regions) {
            let regionCode = region.fixedSymbol || code;
            this.translatedWords["r_" + regionCode] = this.translation["r_" + regionCode] ?? "";
          }
        } else {
          this.translatedWords[code] = this.translation[code] ?? "";
        }
      }
      if (this.baseName) {
        const detectLang = await Rpc.Regions.detectLang(this.baseName);
        this.mayNeedFix = this.typingLanguage !== detectLang.language;
      }
    },

    async initTranslationData() {
      this.isTextual = TRANSLATABLE_TEXT_RENDERERS.includes(this.fieldConfig.renderer);
      this.isCurrency = TRANSLATABLE_CURRENCY_RENDERERS.includes(this.fieldConfig.renderer);

      await this.prepareListLanguage();
      this.translatedWords = {};

      if (this.isTextual) {
        await this.initTextFieldTranslationData();
      } else if (this.isCurrency) {
        const valueOrDefault = (code) => {
          if (!this.translation[code] || !this.translation[code]) {
            return defaultCurrencyValForRegion(code);
          }
          return this.translation[code];
        }

        for (let code in this.languages) {
          if (this.languages[code].hasMoreRegion) {
            this.translatedWords["r_" + code] = valueOrDefault("r_" + code);
            this.translatedWords[code] = this.translation[code] ?? "";
            for (let region of this.languages[code].regions) {
              let regionCode = region.fixedSymbol || code;
              this.translatedWords["r_" + regionCode] = valueOrDefault("r_" + regionCode);
            }
          } else {
            this.translatedWords[code] = valueOrDefault(code);
          }
        }
      } else {
        for (let code in this.languages) {
          if (this.languages[code].hasMoreRegion) {
            this.translatedWords["r_" + code] = this.translation["r_" + code];
            this.translatedWords[code] = this.translation[code];
            for (let region of this.languages[code].regions) {
              let regionCode = region.fixedSymbol || code;
              this.translatedWords["r_" + regionCode] = this.translation["r_" + regionCode];
            }
          } else {
            this.translatedWords[code] = this.translation[code];
          }
        }
      }

    },
    async preparationInterfaceLangList() {
      let interfaceLanguages = await Rpc.AppTranslations.languageInSelectedInterfaceLanguage();
      let modifiedLanguages = {};
      Object.keys(interfaceLanguages).forEach(key => {
        modifiedLanguages[key] = {
          name: interfaceLanguages[key],
        };
      });
      return modifiedLanguages;
    },
    async preparationRegionLangList() {
      const regionsConfig = await Rpc.Regions.loadRegionsConfig();

      const languagesToRegions = {};
      const regions = regionsConfig.regions;
      regions.forEach(region => {
        if (!languagesToRegions[region.baseLanguage]) {
          languagesToRegions[region.baseLanguage] = [];
        }
        languagesToRegions[region.baseLanguage].push(region);
      })
      let finalLanguageList = {};
      for (let languagesCode in languagesToRegions) {
        let regions = languagesToRegions[languagesCode];
        if (regions.length > 1) {
          finalLanguageList[languagesCode] = {
            hasMoreRegion: true,
            regions
          };
        } else {
          finalLanguageList[languagesCode] = {
            hasMoreRegion: false
          };
        }
      }
      return finalLanguageList;
    },
    async prepareListLanguage() {
      if (this.interfaceTranslationEnabled && this.customerTranslationEnabled) {
        if (!this.languages) {
          let regionLanguages = await this.preparationRegionLangList();
          let interfaceLanguages = await this.preparationInterfaceLangList();
          this.languages = {...interfaceLanguages, ...regionLanguages};
        }
      } else {
        if (this.interfaceTranslationEnabled) {
          if (!this.languages) {
            this.languages = await this.preparationInterfaceLangList();
          }
        } else if (this.customerTranslationEnabled) {
          if (!this.languages) {
            this.languages = await this.preparationRegionLangList();
          }
        }
      }
      const allLanguages = SessionManager.regionsConfig.allLanguages;
      for (const lang in this.languages) {
        if (!this.languages[lang].hasMoreRegion) {
          this.languages[lang].hasMoreRegion = false;
        }
        const matchingLanguage = allLanguages.find(language => language.code === lang);
        if (matchingLanguage) {
          this.languages[lang].name = matchingLanguage.sessionName;
        }
      }

      // translate language names to interface namse 'polish -> polski'
      for (let code in this.languages) {
        let lang = this.languages[code];

        if (AppTranslations.langNamesInInterfaceLanguage[code]) {
          lang.name = AppTranslations.langNamesInInterfaceLanguage[code];
        }
      }

    },
    async fixData() {
      this.load = true;
      const detectLang = await Rpc.Regions.detectLang(this.baseName);
      const translatedFixedText = await Rpc.Regions.translate(detectLang.language, this.typingLanguage, this.baseName);
      const translatedOldBaseName = await Rpc.Regions.translate(this.typingLanguage, detectLang.language, this.baseName);
      this.baseName = translatedFixedText;
      this.translatedWords[detectLang.language] = translatedOldBaseName;
      this.translatedWords[this.typingLanguage] = translatedFixedText;
      this.$set(this.translatedWords, detectLang.language, translatedOldBaseName);
      this.$set(this.translatedWords, this.typingLanguage, translatedFixedText);
      this.translatedWords['x'] = 1;
      this.formField.translations.def = translatedFixedText;
      this.objDef.def = this.formField.translations.def;
      this.load = false;
    },
    async fixTranslations() {
      let confirmed = await DialogManager.yesNo(
          $tr('textInputTranslationDialog.Attention', 'Attention'),
          $tr("textInputTranslationDialog.text",
              "Do you want the value to be converted to the currently selected language in the application?"),
          false,
          $tr("textInputTranslationDialog.Apply", "Apply"),
          $tr("textInputTranslationDialog.Cancel", "Cancel")
      );
      if (confirmed) {
        await this.fixData();
      }
    },

    toggleRegions(langKey) {
      this.$set(this.expandedRegions, langKey, !this.expandedRegions[langKey]);
    },
    toggleReadOnlyRegions(langKey) {
      this.$set(this.expandedReadOnlyRegions, langKey, !this.expandedReadOnlyRegions[langKey]);
    }
  },
  props: {
    translation: {default: null},
    typingLanguage: {default: null},
    requiredLangForDb: {default: null},
    interfaceTranslationEnabled: {default: null},
    customerTranslationEnabled: {default: null},
    formField: {default: null},
    fieldConfig: {default: null},
    openFromGrid: {default: false}
  },

  watch: {
    "formField.value": async function (val) {
      console.log(val)
    },
  },
  data() {

    return {
      isCurrency: false,
      baseSet: false,
      isTextual: false,
      unsavedChanges: false,

      mayNeedFix: false,
      objDef: {},
      resolve: null,
      readyTranslationsToSave: {},
      languages: null,
      langs: AppTranslations.langs,
      baseNameLabel: "",
      baseName: "",
      translatedWords: {},
      expandedRegions: {},
      expandedReadOnlyRegions: {},
      load: false,
      calculatePricesButtonEnabled: false,
    };
  }
}
</script>

<style scoped>
.modal-body {
  max-height: 75vh;
}

.form-group {
  margin-bottom: 1rem;
}

b-form-input {
  max-width: 90%;
}

.text-center {
  text-align: center;
}

.currentLanguage {
  font-size: 1.5rem;
}

.d-flex.align-items-center .fa-language {
  font-size: 1rem;
  line-height: 1.5;
}

b-card {
  border: 1px solid #ddd;
  padding: 1rem;
}

.d-flex.align-items-center .translation-button {
  height: auto;
  align-self: stretch;
  display: flex;
  align-items: center;
  justify-content: center;
}

.translation-button .icon-language {
  font-size: 1rem;
}

.info-button:hover .tooltip-inner {
  animation: blink 0.5s step-end infinite alternate;
}

@keyframes blink {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}
</style>
